import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

export default function HelpSupport() {
  return (
    <Box p={3}>
      {/* Header */}
      <Typography variant="h5" fontWeight="bold">
        Help & Support
      </Typography>
      <Typography color="text.secondary" mb={3}>
        Get help with your vendor account and services
      </Typography>

      {/* Quick Help Cards */}
      <Grid container spacing={2} mb={4}>
        {[
          "Account Issues",
          "Payments Support",
          "Property Listings",
          "Booking Problems"
        ].map((title) => (
          <Grid item xs={12} md={3} key={title}>
            <Card sx={{ cursor: "pointer", "&:hover": { boxShadow: 6 } }}>
              <CardContent sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <HelpOutlineIcon color="primary" />
                <Typography fontWeight="500">{title}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={3}>
        {/* FAQs */}
        <Grid item xs={12} md={6}>
          <Typography fontWeight="bold" mb={1}>
            Frequently Asked Questions
          </Typography>

          {[
            {
              q: "How do I add a property?",
              a: "Go to Add Property in the sidebar and fill in details."
            },
            {
              q: "How do I reset my password?",
              a: "Go to Settings → Password & Security."
            },
            {
              q: "When do I receive payments?",
              a: "Payments are processed weekly."
            },
            {
              q: "How do I contact support?",
              a: "Use the phone or email listed on the right."
            }
          ].map((item, index) => (
            <Accordion key={index}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{item.q}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography color="text.secondary">{item.a}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>

        {/* Contact Support Info */}
        <Grid item xs={12} md={6}>
          <Typography fontWeight="bold" mb={1}>
            Contact Support
          </Typography>

          <Card>
            <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              
              <Box display="flex" alignItems="center" gap={1}>
                <SupportAgentIcon color="primary" />
                <Typography fontWeight="600">Support Team</Typography>
              </Box>

              <Box display="flex" alignItems="center" gap={1}>
                <EmailIcon color="action" />
                <Typography>contact@thegreathimalayas.com</Typography>
              </Box>

              <Box display="flex" alignItems="center" gap={1}>
                <PhoneIcon color="action" />
                <Typography>+91 9883587965</Typography>
              </Box>

              <Divider />

              <Typography color="text.secondary" fontSize={14}>
                Response Time: Within 24 hours
              </Typography>

            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Divider sx={{ my: 4 }} />

      {/* Footer Note */}
      <Typography color="text.secondary" fontSize={14}>
        Need urgent help? Contact our support team during business hours.
      </Typography>
    </Box>
  );
}
